/*
 * File: \lib\mxNative.js
 * File Created: 2022-04-02 11:05:36
 * Author: Li Haifeng
 * -----
 * Last Modified: 2023-04-13 16:54:52
 * Modified By: Ocean Li ���
 */
import defaultAPI from './util/defaultApi.js'
import ModuleCore from '@midea/mx-cli-module-core'
import apis from './apis'

export default class Native extends ModuleCore {
  constructor(config) {
    super({
      apis: apis,
      useNative: true,
      nativeApis: defaultAPI,
    })

    this.config = config
    this.mxNativeApis = {}
    this.apis = apis

    this.mxGenerator.generate(
      this.apis.map((a) => {
        this.mxNativeApis[a] = this.nativeApis[a]
        return { name: a, fn: this.nativeApis[a] }
      })
    )
  }

  // 重新设置全局api
  wrapGlobalApis() {
    this.apis.forEach((a) => {
      this.mxGenerator.setApi({ name: a, fn: this.mxNativeApis[a] })
    })
  }

  addApis(apis) {
    if (!apis || apis.length <= 0) {
      return
    }
    const apiName = apis[0][1]
    if (this.apis.indexOf(apiName) < 0) {
      this.apis.push(apiName)
    }
    let result = this.native.addApis(apis)
    result.forEach(({ name, fn }) => {
      this.mxNativeApis[name] = fn
    })
    this.mxGenerator.addOtherApis(result)
  }

  setApis(apis) {
    apis.forEach((api) => {
      this.mxGenerator.setApi(api)
    })
  }
}
